"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_get_1 = __importDefault(require("lodash.get"));

function get(collection, path) {
  return lodash_get_1.default(collection, path);
}

exports.get = get;